export default "__VITE_ASSET__63b7fd44__"